/*
  Hover-to-open for the desktop mega nav (snippets/navigation.liquid).

  Click handling lives in bb-global.min.js (clickToOpenMegaNav) and is left untouched, so
  touch and keyboard users keep click-to-open. This only adds mouse hover on desktop: it sets
  the same classes that click handler sets, and closes through the modal underlay so the
  existing close logic runs.
*/
(function () {
  const OPEN_DELAY = 120;
  const CLOSE_DELAY = 250;
  const SUB_NAV_DELAY = 150;
  const OPEN_CLASS = 'menu-open';
  const SUB_OPEN_CLASS = 'nav-third-level-open';

  // Matches the 1201px desktop breakpoint used by clickToOpenMegaNav.
  const desktopMouse = window.matchMedia('(min-width: 1201px) and (hover: hover) and (pointer: fine)');
  const navItems = document.querySelectorAll('.navigation-snippet [data-nav-item]');
  const underlay = document.querySelector('[data-modal-underlay]');
  if (!navItems.length || !underlay) return;

  let navTimer;
  let subNavTimer;

  const isMouse = (event) => event.pointerType === 'mouse' && desktopMouse.matches;
  const openItem = () => document.querySelector(`.navigation-snippet [data-nav-item].${OPEN_CLASS}`);

  function open(item) {
    if (item.classList.contains(OPEN_CLASS)) return;

    navItems.forEach((navItem) => navItem.classList.remove(OPEN_CLASS));
    item.classList.add(OPEN_CLASS);
    document.body.classList.add('modal-visible', 'modal-menu');
    document.body.classList.remove('search-open');

    if (!item.querySelector(`.${SUB_OPEN_CLASS}`)) {
      item.querySelector('[data-sub-nav-toggle]')?.classList.add(SUB_OPEN_CLASS);
    }
  }

  function close() {
    if (openItem()) underlay.click();
  }

  navItems.forEach((item) => {
    // Items without children are plain links and have nothing to open.
    if (!item.querySelector('[data-nav-second-level-wrapper]')) {
      item.addEventListener('pointerenter', (event) => {
        if (!isMouse(event)) return;
        clearTimeout(navTimer);
        navTimer = setTimeout(close, CLOSE_DELAY);
      });
      return;
    }

    item.addEventListener('pointerenter', (event) => {
      if (!isMouse(event)) return;
      clearTimeout(navTimer);
      // Already browsing the menu, so switch straight away rather than waiting again.
      if (openItem()) open(item);
      else navTimer = setTimeout(() => open(item), OPEN_DELAY);
    });

    item.addEventListener('pointerleave', (event) => {
      if (!isMouse(event)) return;
      clearTimeout(navTimer);
      navTimer = setTimeout(close, CLOSE_DELAY);
    });

    // Second-level items with children show their third level on hover. The delay lets the
    // pointer cross other items on its way to the third-level column without switching.
    item.querySelectorAll('[data-sub-nav-toggle]').forEach((subItem) => {
      subItem.addEventListener('pointerenter', (event) => {
        if (!isMouse(event)) return;
        clearTimeout(subNavTimer);
        subNavTimer = setTimeout(() => {
          item.querySelector(`.${SUB_OPEN_CLASS}`)?.classList.remove(SUB_OPEN_CLASS);
          subItem.classList.add(SUB_OPEN_CLASS);
        }, SUB_NAV_DELAY);
      });

      subItem.addEventListener('pointerleave', () => clearTimeout(subNavTimer));
    });
  });
})();
